/* InputRadioControlComponent.js */

"use strict";

const InputBaseSingleOptionSelectionControlComponent = require("@gluenetworks/input_base_control")
    .OptionSelection.Single;
const Renderer = require("./InputRadioControlRenderer");
const _ = require("lodash");

class InputRadioControlComponent extends InputBaseSingleOptionSelectionControlComponent {
    /**
     * @schema.name Input Radio Control
     * @schema.package @gluenetworks/input_radio_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.InputRadio
     * @schema.events ["Horizontal", "Options", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.horizontal.name horizontal
     * @schema.configuration.horizontal.type boolean
     * @schema.configuration.horizontal.default false
     * @schema.configuration.horizontal.required false
     *
     * @schema.configuration.options.example [{ label: 'Number 1', value: { valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } }, disabled: true },{ label: 'Number 2', value: { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } } },{ label: 'Number 3', value: { valueProp1: 'blah3', valueProp2: { somethin: 'somethin3' } }, disabled: true },{ label: 'Number 4', value: { valueProp1: 'blah4', valueProp2: { somethin: 'somethin4' } } },{ label: 'Number 5', value: { valueProp1: 'blah5', valueProp2: { somethin: 'somethin5' } } }]
     *
     * @schema.configuration.value.example { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } }
     *
     */

    constructor(configOptions) {
        super(configOptions);

        this._horizontal = _.get(configOptions, "horizontal", false);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._horizontal = undefined;
        this._options = undefined;
        this._disabled = undefined;
        this._invalid = undefined;
        this._visible = undefined;
        this._value = undefined;
        this._darkTheme = undefined;
        this._theme = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setHorizontal.name setHorizontal
     * @schema.methods.setHorizontal.description Sets the horizontal layout state of the control and returns an instance of the control for chainability
     * @schema.methods.setHorizontal.returns Instance of the control
     * @schema.methods.setHorizontal.parameters.newVal.name newVal
     * @schema.methods.setHorizontal.parameters.newVal.description The horizontal layout state of the control
     * @schema.methods.setHorizontal.parameters.newVal.type boolean
     */
    setHorizontal(newVal) {
        this._horizontal = newVal;
        this.emit("Horizontal", this._horizontal);
        return this;
    }
    /**
     * @schema.methods.isHorizontal.name isHorizontal
     * @schema.methods.isHorizontal.description Returns the horizontal layout state of the control
     * @schema.methods.isHorizontal.returns boolean
     */
    isHorizontal() {
        return this._horizontal;
    }
    get horizontal() {
        return this.isHorizontal();
    }
    set horizontal(newVal) {
        return this.setHorizontal(newVal);
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = InputRadioControlComponent;
